var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCncYellowGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-994 4089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.647,286.959V287H98.395l-.083-.041a4.622,4.622,0,0,1,.529-2.118L95.22,281.22h-.608L95,281l-5.737-5.737-.9,5.3,1.151.66H81.041V282.3a4.654,4.654,0,0,1,4.606,4.661",
    transform: "translate(914 -4355)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.923,271.229l.01-.053c-.011,0-.02-.011-.031-.013Z",
    transform: "translate(914 -4355)",
    fill: "#16b240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.841,284.841a4.628,4.628,0,0,1,4.118-2.547l.041.082v-1.155H95.221Z",
    transform: "translate(914 -4355)",
    fill: "#16b240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,281l.764-.439-1.233-7.266-.021-.1a1.032,1.032,0,0,1-.369-2.031l.061.066L93.789,269H90.334l-.4,2.176a1.029,1.029,0,0,1-.4,2.018l.061.1-.334,1.967Z",
    transform: "translate(914 -4355)",
    fill: "#16b240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.789,269l.411,2.229-.061-.065a1.032,1.032,0,0,0,.369,2.03l.021.1,1.234,7.266-1.151.66H103v1.156l-.041-.082a4.656,4.656,0,0,0-4.647,4.665l.083.041H85.647v-.041A4.655,4.655,0,0,0,81,282.294l.041.082V281.22h8.471l-1.151-.66,1.234-7.266-.062-.1a1.032,1.032,0,0,0,.37-2.03l.021.065L90.335,269h.987",
    transform: "translate(914 -4355)",
    fill: "none",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(994 -4089)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCncYellowGreen);
export default __webpack_public_path__ + "static/media/cnc_yellow_green.f6b61163b79a94dbe09d87063bc45af7.svg";
export { ForwardRef as ReactComponent };